"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginLeveragesReducer = void 0;
var _actionTypes = require("../actionTypes");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Helper function to safely get leverages from sessionStorage
var getMarginLeveragesFromStorage = function getMarginLeveragesFromStorage() {
  if (typeof sessionStorage === 'undefined') {
    return {};
  }
  try {
    var stored = sessionStorage.getItem('userMarginLeverages');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Failed to parse margin leverages from sessionStorage:', error);
    return {};
  }
};

// Initial State factory function (lazy initialization)
var getInitialState = function getInitialState() {
  return {
    leverages: getMarginLeveragesFromStorage(),
    fetching: false
  };
};

// Reducer
var marginLeveragesReducer = exports.marginLeveragesReducer = function marginLeveragesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _actionTypes.REQUEST_MARGIN_LEVERAGES:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });
    case _actionTypes.SET_MARGIN_LEVERAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        leverages: _objectSpread(_objectSpread({}, state.leverages), {}, _defineProperty({}, payload.instrumentId, payload.leverage))
      });
    default:
      return state;
  }
};